<page-layout>
  <ng-container content>
    <div class="d-flex align-items-center justify-content-center flex-column text-center flex-grow-1">
      <mbs-error [type]="errorType.NotFound"></mbs-error>
    </div>
  </ng-container>
</page-layout>
